import { MarketButton } from '@market/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withI18n } from '@squareup/service-i18n/components';
import { PortionOfSalesContent } from '../portion-of-sales-content/PortionOfSalesContent';
import styles from './PortionOfSalesPage.module.css';

const DEFAULT_PERCENTAGE = 10;

export interface PortionOfSalesPageProps {
  readonly estimatedDailySalesAmountCents?: number;
  readonly onNext: (percentage: number) => void;
}

export const PortionOfSalesPage = ({
  estimatedDailySalesAmountCents,
  onNext,
}: PortionOfSalesPageProps) => {
  const { t } = useTranslation();
  const [percentage, setPercentage] = useState(DEFAULT_PERCENTAGE);

  const handleNext = () => {
    onNext(percentage);
  };

  return (
    <div className={styles.content}>
      <h2 className="heading-30">
        {t('bankingShared.creditCard.portionOfSales.title')}
      </h2>

      <PortionOfSalesContent
        percentage={percentage}
        estimatedDailySalesAmountCents={estimatedDailySalesAmountCents}
        onPercentageChange={setPercentage}
      />

      <MarketButton rank="primary" onClick={handleNext}>
        {t('bankingShared.creditCard.portionOfSales.next')}
      </MarketButton>
    </div>
  );
};

export const PortionOfSalesPageI18n = withI18n(PortionOfSalesPage);
